import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from '@nuxtjs/composition-api'
import { OrderEmpty, useMenuModel, MenuCategories, MenuList } from '@entities/menu'
import { Header } from '@widgets/header'
import { Stocks } from '@entities/stocks'


export default /*#__PURE__*/_defineComponent({
  __name: 'Menu',
  props: {
  verticalScroll: {
    type: Number,
    required: false,
    default: 0
  }
},
  emits: ['togglePrecheck', 'googleTranslate'],
  setup(__props, { emit: emits }) {

const props = __props



const menuModel = useMenuModel()



const positionClass = ref<boolean>(false)

const positionModal = (val: boolean) => {
  positionClass.value = val
}

const togglePrecheck = () => {
  emits('togglePrecheck')
}

const googleTranslate = () => {
  emits('googleTranslate')
}

onMounted(() => {
  window.scroll(0, props.verticalScroll)
})

return { __sfc: true,emits, menuModel, props, positionClass, positionModal, togglePrecheck, googleTranslate, OrderEmpty, MenuCategories, MenuList, Header, Stocks }
}

})